import React, {useState} from "react";
import {Breadcrumb} from "semantic-ui-react";
import {NavLink} from "react-router-dom";
import i18n from "../../../../locale/i18n";
import MailBoxAuthLogin from "./MailBoxAuthLogin";
import MailBoxAuthRequestReset from "./MailBoxAuthRequestReset";
import MailBoxAuthSetNewPin from "./MailBoxAuthSetNewPin";

interface MailBoxAuthPageProps {
    isInitialized: boolean;

    onAuthenticated(token: string): void;
}
const t = i18n.t.bind(i18n);

type AuthStep = 'request_reset' | 'login' | 'set_new_pin';

function MailBoxAuthPage(props: MailBoxAuthPageProps) {
    const { onAuthenticated } = props;

    const [step, setStep] = useState<AuthStep>(props.isInitialized ? 'login' : 'request_reset');

    return <>

        <div className={"sticky-header"}>
            <div className={"ui container"}>
                <h3><Breadcrumb icon="right angle" sections={[
                    {
                        key: '1',
                        as: NavLink,
                        to: '/mailbox',
                        content: `${t("Route.MailBox")}`, link: true
                    }
                ]}/></h3>

                {step === 'request_reset' && <MailBoxAuthRequestReset
                  isInitialized={props.isInitialized}
                  onResetRequested={() => setStep('set_new_pin')}
                  onClickCodeAlreadyReceived={() => setStep('set_new_pin')}
                  onClickBackToLogin={() => setStep('login')}
                />}

                {step === 'login' && <MailBoxAuthLogin
                  onAuthenticated={onAuthenticated}
                  onClickReset={() => setStep('request_reset')}
                />}

                {step === 'set_new_pin' && <MailBoxAuthSetNewPin
                  onSuccess={() => {
                  setStep('login');
                  }}
                  onCancel={() => {
                      setStep(props.isInitialized ? 'login' : 'request_reset');
                  }}
                />}

            </div>
        </div>

    </>;
}

export default MailBoxAuthPage;